import FormControlLabel from "@material-ui/core/FormControlLabel";
import MUIRadio from "@material-ui/core/Radio";
import Tooltip from "@material-ui/core/Tooltip";
import React, { FC } from "react";
import { withStyles } from "@material-ui/core/styles";

import classes from "./RadioButtonOption.module.scss";
import { truncateText } from "../../../../../helpers/truncateText";

type RadioButtonOptionProps = {
  label: string;
  value: string | number;
};

const Radio = withStyles({
  root: {
    "&$checked": {
      color: "#FF7A59",
    },
  },
  checked: {},
})((props: any) => <MUIRadio color="default" {...props} />);

const RadioButtonOption: FC<RadioButtonOptionProps> = ({ label, value }) => {
  return (
    <Tooltip title={label}>
      <FormControlLabel
        className={classes.radioButtonOption}
        value={value}
        control={<Radio color="primary" className={classes.radio} />}
        label={truncateText(label, 20)}
      />
    </Tooltip>
  );
};

export default RadioButtonOption;
